<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Меню</h2>
          <router-link v-if="!isBannerMgr" :to="{name : 'TopmenuCreate'}">
            <button class="btn btn-primary">
              Меню
              <i class="fas fa-plus"></i>
            </button>
          </router-link>
        </div>
      </div>
    </div>

    <br>

    <div v-if="menus !== null">
      <div v-for="(menu, i) in this.menus" :key="i" class="row">
        <div class="card w-100">
          <div class="px-3 pt-2 d-flex">
            <h3 class="mr-auto p-2 title-3">{{ menu.name }}</h3>

            <div v-if="!isBannerMgr" class="p-2">
              <router-link :to="{name : 'TopmenuEdit', params: {id: menu.id}}">
                <button class="btn btn-info btn-sm">
                  <i class="fas fa-edit"></i>
                  Менюг засах
                </button>
              </router-link>

              <button
                v-if="!menu.staticFlag && menu.status == 1"
                class="btn btn-warning btn-sm mx-2"
                @click="changeStatus(menu, 'top')"
              >
                <i class="fas fa-times"></i>
                Менюг нийтлэхээ болих
              </button>
              
              <button
                v-if="!menu.staticFlag && menu.status != 1"
                class="btn btn-success btn-sm mx-2"
                @click="changeStatus(menu, 'top')"
              >
                <i class="fas fa-upload"></i>
                Менюг нийтлэх
              </button>
              
              <button
                v-if="!menu.staticFlag"
                class="btn btn-danger btn-sm"
                @click="deleteMenu(menu.id, false)"
              >
                <i class="fas fa-trash"></i>
                Менюг устгах
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-top-campaign">
                <tbody>
                  <tr v-for="(submenu, i) in menu.childEntries.rows" :key="i">
                    <td>
                      <div v-if="submenu.layout == 9">{{ submenu.name }}</div>
                      <router-link
                        v-else-if="!(submenu.layout < 5 && submenu.layout > 0)"
                        :to="{name: 'EntryEdit', params: {type: 'content', entryId: submenu.id, parentId: menu.id}}"
                      >{{ submenu.name }}</router-link>
                      <router-link
                        v-else-if="submenu.layout < 5 && submenu.layout > 0"
                        :to="{name: 'SubmenuShow', params: {parentId: submenu.id}}"
                      >{{ submenu.name }}</router-link>
                    </td>
                    <td>{{ getLayoutType(submenu.layout) }}</td>
                    <td></td>
                    <td>
                      <span
                        class="badge badge-pill badge-secondary"
                        style="font-weight: 400;"
                      >{{ submenu.status == 1 ? "Published" : "draft" }}</span>
                    </td>
                    <td v-if="!isBannerMgr">
                      <router-link :to="{name : 'SubmenuEdit', params: {id: submenu.id}}">
                        <button type="button" class="btn btn-info btn-sm">
                          <i class="fas fa-edit"></i>
                        </button>
                      </router-link>
                      <button
                        v-if="submenu.status != 1 && !submenu.staticFlag"
                        type="button"
                        class="btn btn-success btn-sm mx-2 status-btn"
                        @click="changeStatus(submenu, 'sub')"
                      >
                        <i class="fas fa-upload"></i>
                      </button>
                      <button
                        v-if="submenu.status == 1 && !submenu.staticFlag"
                        type="button"
                        class="btn btn-warning btn-sm mx-2 status-btn"
                        @click="changeStatus(submenu, 'sub')"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                      <button
                        v-if="!submenu.staticFlag"
                        type="button"
                        class="btn btn-danger btn-sm"
                        @click="deleteMenu(submenu.id, true)"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!isBannerMgr">
                    <router-link :to="{name : 'SubmenuCreate', params: {parentId: menu.id}}">
                      <button class="btn btn-primary btn-sm mt-2">
                        Дэд меню
                        <i class="fas fa-plus"></i>
                      </button>
                    </router-link>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<style>
.status-btn {
  width: 33px;
}
</style>

<script>
import MenuService from "@/services/MenuService";
import DeleteDialog from "@/mixins/DeleteDialog.js";
import EntryList from "@/mixins/EntryList.js";

export default {
  name: "MenusList",

  mixins: [DeleteDialog, EntryList],

  created() {
    this.$store.dispatch("setLoading", true);
    this.getMenus();
  },

  data() {
    return {
      menus: null
    };
  },

  methods: {
    getLayoutType(key) {
      if (key == 0) return "Menu";
      if (key == 1) return "Article 1 column";
      if (key == 2) return "Article 2 column";
      if (key == 3) return "Card list";
      if (key == 4) return "Branch list";
      if (key == 5) return "HTML content";
      if (key == 6) return "Branch";
      if (key == 7) return "Card";
      if (key == 9) return "Custom";
      return "Wrong type";
    },

    getMenus() {
      MenuService.getMenusList({}).then(response => {
        if (response.status == 200 && response.data.success == true)
          this.menus = response.data.payload;

        this.$store.dispatch("setLoading", false);
      });
    },

    deletedHandlerTop(id) {
      let index = this.menus.map(menu => menu.id).indexOf(id);
      if (index > -1) this.menus.splice(index, 1);
    },

    deletedHandlerSub(id) {
      for (var i = 0; i < this.menus.length; i++) {
        let index = this.menus[i].childEntries.rows
          .map(submenu => submenu.id)
          .indexOf(id);
        if (index > -1) {
          this.menus[i].childEntries.rows.splice(index, 1);
          break;
        }
      }
    },

    deleteMenu(id, isSubMenu) {
      this.confirmDelete(
        id,
        isSubMenu ? "Дэд меню устгах!" : "Меню устгах!",
        "Та энэ менюг устгах уу?",
        isSubMenu ? MenuService.changeSubStatus : MenuService.changeTopStatus,
        isSubMenu ? this.deletedHandlerSub : this.deletedHandlerTop
      );
    }
  }
};
</script>